module.exports = __webpack_public_path__ + "img/DeliveredActive.0a5996ed.svg";